import React, { useState, useEffect } from 'react';
import './Clients.css';

const Clients = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const clientLogos = [
    { name: "AAJoyland", logo: "/client_logos/AAJoyland.jpg" },
    { name: "AhmedGroup", logo: "/client_logos/AhmedGroup.jpg" },
    { name: "AlHamza", logo: "/client_logos/AlHamza.png" },
    { name: "Alkaram", logo: "/client_logos/Alkaram.png" },
    { name: "AMRELI", logo: "/client_logos/AMRELI.jpg" },
    { name: "ArtisticMilliners", logo: "/client_logos/ArtisticMilliners.png" },
    { name: "AVRIOC", logo: "/client_logos/AVRIOC.png" },
    { name: "BinateDigital", logo: "/client_logos/BinateDigital.png" },
    { name: "BR", logo: "/client_logos/BR.jpg" },
    { name: "ChalFoundation", logo: "/client_logos/ChalFoundation.png" },
    { name: "Chaseup", logo: "/client_logos/Chaseup.png" },
    { name: "Cociofy", logo: "/client_logos/Cociofy.png" },
    { name: "CodeLabs", logo: "/client_logos/CodeLabs.jpg" },
    { name: "Codup", logo: "/client_logos/Codup.png" },
    { name: "Confiance", logo: "/client_logos/Confiance.jpg" },
    { name: "Consult", logo: "/client_logos/Consult.png" },
    { name: "Digitz", logo: "/client_logos/Digitz.png" },
    { name: "Dollar", logo: "/client_logos/Dollar.jpg" },
    { name: "Ebrahim", logo: "/client_logos/Ebrahim.jpg" },
    { name: "eocean", logo: "/client_logos/eocean.png" },
    { name: "FFBL", logo: "/client_logos/FFBL.png" },
    { name: "FinalRentals", logo: "/client_logos/FinalRentals.png" },
    { name: "Freedom", logo: "/client_logos/Freedom.png" },
    { name: "Funadiq", logo: "/client_logos/Funadiq.jpg" },
    { name: "Gatron", logo: "/client_logos/Gatron.png" },
    { name: "Genesis", logo: "/client_logos/Genesis.jpg" },
    { name: "GetzParma", logo: "/client_logos/GetzParma.png" },
    { name: "GPS", logo: "/client_logos/GPS.jpg" },
    { name: "GulAhmed", logo: "/client_logos/GulAhmed.png" },
    { name: "HBFC", logo: "/client_logos/HBFC.png" },
    { name: "Herbion", logo: "/client_logos/Herbion.jpg" },
    { name: "Hilal", logo: "/client_logos/Hilal.png" },
    { name: "Homecare", logo: "/client_logos/Homecare.jpg" },
    { name: "Hunar", logo: "/client_logos/Hunar.png" },
    { name: "IBL", logo: "/client_logos/IBL.png" },
    { name: "IGLOO", logo: "/client_logos/IGLOO.png" },
    { name: "ImranCrown", logo: "/client_logos/ImranCrown.jpg" },
    { name: "Innovative", logo: "/client_logos/Innovative.png" },
    { name: "InternationalTexttiles", logo: "/client_logos/InternationalTexttiles.png" },
    { name: "JCVision", logo: "/client_logos/JCVision.png" },
    { name: "JdotAwan", logo: "/client_logos/JdotAwan.jpg" },
    { name: "Knot", logo: "/client_logos/Knot.jpg" },
    { name: "KPL", logo: "/client_logos/KPL.png" },
    { name: "LI", logo: "/client_logos/LI.jpg" },
    { name: "Logistics", logo: "/client_logos/Logistics.png" },
    { name: "Makkays", logo: "/client_logos/Makkays.jpg" },
    { name: "MeriSehat", logo: "/client_logos/MeriSehat.png" },
    { name: "MEtWorld", logo: "/client_logos/MEtWorld.jpg" },
    { name: "Multinet", logo: "/client_logos/Multinet.png" },
    { name: "MyCart", logo: "/client_logos/MyCart.png" },
    { name: "MyWater", logo: "/client_logos/MyWater.png" },
    { name: "Natural2go", logo: "/client_logos/Natural2go.jpg" },
    { name: "NAXXA", logo: "/client_logos/NAXXA.png" },
    { name: "Nepean", logo: "/client_logos/Nepean.png" },
    { name: "NexGenTech", logo: "/client_logos/NexGenTech.png" },
    { name: "NishMAN", logo: "/client_logos/NishMAN.png" },
    { name: "nisum", logo: "/client_logos/nisum.png" },
    { name: "Nordica", logo: "/client_logos/Nordica.png" },
    { name: "Ordercall", logo: "/client_logos/Ordercall.png" },
    { name: "Orient", logo: "/client_logos/Orient.png" },
    { name: "Pakistan", logo: "/client_logos/Pakistan.png" },
    { name: "Pakola", logo: "/client_logos/Pakola.png" },
    { name: "PeoplesSteelMills", logo: "/client_logos/PeoplesSteelMills.jpg" },
    { name: "Pepsico", logo: "/client_logos/Pepsico.png" },
    { name: "PrintShrint", logo: "/client_logos/PrintShrint.png" },
    { name: "SaeedGhani", logo: "/client_logos/SaeedGhani.png" },
    { name: "Scilife", logo: "/client_logos/Scilife.png" },
    { name: "Secure", logo: "/client_logos/Secure.png" },
    { name: "SJG", logo: "/client_logos/SJG.png" },
    { name: "Skylink", logo: "/client_logos/Skylink.png" },
    { name: "SmartSolutins", logo: "/client_logos/SmartSolutins.jpg" },
    { name: "SocialMedia", logo: "/client_logos/SocialMedia.png" },
    { name: "SportsPavilion", logo: "/client_logos/SportsPavilion.png" },
    { name: "Stimulus", logo: "/client_logos/Stimulus.png" },
    { name: "SynergiesSourcing", logo: "/client_logos/SynergiesSourcing.png" },
    { name: "SynergiesWorldwide", logo: "/client_logos/SynergiesWorldwide.png" },
    { name: "Synergy", logo: "/client_logos/Synergy.png" },
    { name: "T", logo: "/client_logos/T.jpg" },
    { name: "TopRoof", logo: "/client_logos/TopRoof.png" },
    { name: "TPLTrakker", logo: "/client_logos/TPLTrakker.png" },
    { name: "TRIFIT", logo: "/client_logos/TRIFIT.png" },
    { name: "Trojan", logo: "/client_logos/Trojan.jpg" },
    { name: "UBL", logo: "/client_logos/UBL.png" },
    { name: "Ulker", logo: "/client_logos/Ulker.png" },
    { name: "Watella", logo: "/client_logos/Watella.jpg" },
    { name: "WSA", logo: "/client_logos/WSA.jpg" },
    { name: "Yunus", logo: "/client_logos/Yunus.png" }
  ];

  const testimonials = [
    {
      name: "Sarah Ahmed",
      position: "HR Director",
      company: "TechCorp Pakistan",
      text: "HRCONSOL transformed our recruitment process with their innovative approach and exceptional talent pool. Their expertise in tech recruitment is unmatched.",
      rating: 5
    },
    {
      name: "Mohammad Hassan",
      position: "CEO",
      company: "Manufacturing Plus",
      text: "The blue-collar workforce solutions provided by HRCONSOL have been instrumental in our expansion across the MENA region. Highly recommended!",
      rating: 5
    },
    {
      name: "Aisha Khan",
      position: "Operations Manager",
      company: "StartupHub",
      text: "From executive search to HR outsourcing, HRCONSOL delivers world-class solutions. Their AI-powered HRMS has streamlined our operations significantly.",
      rating: 5
    },
    {
      name: "Ahmed Ali",
      position: "HR Manager",
      company: "Global Tech Solutions",
      text: "Exceptional service and outstanding results. HRCONSOL's team understands our needs and delivers beyond expectations every time.",
      rating: 5
    },
    {
      name: "Fatima Sheikh",
      position: "Director of Operations",
      company: "MENA Enterprises",
      text: "Professional, reliable, and innovative. HRCONSOL has been our trusted HR partner for over 3 years, and we couldn't be happier with their services.",
      rating: 5
    }
  ];

  // Auto-play carousel
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [testimonials.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="clients" className="clients-section">
      <div className="container">
        <div className="section-header">
          <h2><i className="fas fa-users"></i> Our Clients</h2>
          <p>Trusted by leading organizations across Pakistan and the MENA region</p>
        </div>

        {/* Client Logos Carousel */}
        <div className="client-logos-carousel">
          <h3>Trusted Partners</h3>
          <div className="logos-container">
            <div className="logos-track">
              {[...clientLogos, ...clientLogos].map((client, index) => (
                <div key={index} className="client-logo-item">
                  <img 
                    src={client.logo} 
                    alt={client.name}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  <div className="logo-placeholder" style={{ display: 'none' }}>
                    <span>{client.name}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Testimonials Carousel */}
        <div className="testimonials-carousel">
          <h3>What Our Clients Say</h3>
          <div className="carousel-container">
            <button className="carousel-btn prev" onClick={prevSlide}>
              <i className="fas fa-chevron-left"></i>
            </button>
            
            <div className="carousel-wrapper">
              <div 
                className="carousel-track"
                style={{ 
                  transform: `translateX(-${currentSlide * 100}%)`,
                  transition: 'transform 0.5s ease-in-out'
                }}
              >
                {testimonials.map((testimonial, index) => (
                  <div key={index} className="testimonial-slide">
                    <div className="testimonial-card">
                      <div className="testimonial-content">
                        <div className="stars">
                          {[...Array(testimonial.rating)].map((_, i) => (
                            <i key={i} className="fas fa-star"></i>
                          ))}
                        </div>
                        <p>"{testimonial.text}"</p>
                      </div>
                      <div className="testimonial-author">
                        <h4>{testimonial.name}</h4>
                        <p>{testimonial.position}, {testimonial.company}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            <button className="carousel-btn next" onClick={nextSlide}>
              <i className="fas fa-chevron-right"></i>
            </button>
          </div>

          {/* Carousel Dots */}
          <div className="carousel-dots">
            {testimonials.map((_, index) => (
              <button
                key={index}
                className={`dot ${index === currentSlide ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Clients;
